<div class="row mb-4">
    <div class="col-12">
        <div class="card-info p-4">
            <h5 class="text-main-color text-uppercase">Card information</h5>
            <p class="text-secondary-color text-uppercase">enter card information to complete the payment </p>
            <div class="row">
                <div class="col-12">
                    <div class="form-group bg-white rounded-pill card-number">
                        <div class="input-group mb-3 border-o rounded-pill ">
                            <div class="input-group-prepend ">
                            <img src="imgs/erwaa-٤١.png" alt="" class="img-fluid img-fit card-img ">
                            </div>
                            <input type="text" class="form-control border-0 rounded-pill" placeholder="card number">
                        </div>
                        
                    
                    </div>

                    <div class="form-group bg-white rounded-pill">
                        <div class="input-group mb-3 border-o rounded-pill">
                            <div class="input-group-prepend ">
                            <span class="input-group-text bg-white rounded-pill border-0 text-secondary  "><i class="far fa-user"></i></span>
                            </div>
                            <input type="email" class="form-control border-0 rounded-pill " placeholder="your card name">
                        </div>
                    
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group bg-white rounded-pill">
                        <div class="input-group mb-3 border-o rounded-pill">
                            <div class="input-group-prepend ">
                            <span class="input-group-text bg-white rounded-pill border-0 text-secondary  "><i class="far fa-calendar-alt"></i></span>
                            </div>
                            <input type="date" class="form-control border-0 rounded-pill " placeholder="your card name">
                        </div>
                    
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group bg-white rounded-pill">
                        <div class="input-group mb-3 border-o rounded-pill">
                            <div class="input-group-prepend ">
                            <span class="input-group-text bg-white rounded-pill border-0 text-secondary  "><i class="fas fa-circle"></i></span>
                            </div>
                            <input type="text" class="form-control border-0 rounded-pill " placeholder="cvv">
                        </div>
                    
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-center">
                    <button class="btn rounded-pill bg-secondary-color py-2 px-5 text-white"> <i class="fas fa-dollar-sign d-inline-block dollar rounded-circle border "></i> pay now</button>
                </div>
            </div>
        </div>

    </div>
</div>